/**
 * @Author: WeiZisen
 * @Date: 2021-03-17 14:30:31
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-03-17 14:38:39
 * @Description: 验证规则-菜单管理
 * @FilePath: \Vue_RebarProcess\src\validate\system\menu.js
 */
export let rules = {
  title: [{ required: true, message: '请填写菜单名称', trigger: 'blur' }],
  component: [{ required: true, message: '请填写文件路径', trigger: 'blur' }],
  name: [{ required: true, message: '请填写组件名称', trigger: 'blur' }],
  path: [{ required: true, message: '请填写URL名称', trigger: 'blur' }],
  sort: [{ required: true, message: '请填写序号', trigger: 'blur' }],
  parentId: [{ required: true, message: '请选择', trigger: 'change' }],
}
